import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.0013 0.666016C4.4013 0.666016 0.667969 4.39935 0.667969 8.99935C0.667969 13.5993 4.4013 17.3327 9.0013 17.3327C13.6013 17.3327 17.3346 13.5993 17.3346 8.99935C17.3346 4.39935 13.6013 0.666016 9.0013 0.666016ZM9.83463 13.166H8.16797V11.4993H9.83463V13.166ZM9.83463 9.83268H8.16797V4.83268H9.83463V9.83268Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }